import { Button, Alert } from 'react-bootstrap';
import { FaExclamationTriangle, FaSyncAlt, FaSpinner, FaWhatsapp } from 'react-icons/fa';
import { useRetryInvoiceMutation } from '../../slices/orderApiSlice';
import { toast } from 'react-toastify';

const InvoiceErrorState = ({ orderId, errorMessage, onSuccess }) => {
    const [retryInvoice, { isLoading }] = useRetryInvoiceMutation();

    const handleRetry = async () => {
        try {
            await retryInvoice(orderId).unwrap();
            toast.success('Reintentando crear la factura...');
            if (onSuccess) onSuccess();
        } catch (err) {
            toast.error(err?.data?.message || 'Error al reintentar');
        }
    };

    const handleContactSupport = () => {
        const message = encodeURIComponent(
            `Hola, necesito ayuda con la factura de mi pedido ${orderId}. La factura no pudo ser autorizada.`
        );
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATSAPP_PHONE}&text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <Alert variant="warning" className="p-3 mb-3 border-0 shadow-sm">
            <div className="d-flex align-items-center gap-2 mb-3">
                <FaExclamationTriangle className="text-warning" />
                <span className="fw-bold">Problema con la Factura</span>
            </div>

            <div className="mb-3">
                <p className="mb-2 small">
                    <strong>Tu pago fue exitoso</strong>, pero hubo un problema al autorizar la factura con el SRI.
                </p>
                <p className="mb-0 small text-muted">
                    Por favor, contacta con nuestro soporte para que podamos resolver este problema.
                </p>
            </div>

            {errorMessage && (
                <div className="mb-3 p-2 bg-white rounded small">
                    <strong>Detalle del error:</strong>
                    <p className="mb-0 mt-1 text-muted">{errorMessage}</p>
                </div>
            )}

            <div className="d-flex gap-2 flex-wrap">
                <Button
                    variant="success"
                    size="sm"
                    onClick={handleContactSupport}
                    className="d-flex align-items-center gap-2"
                >
                    <FaWhatsapp />
                    Contactar Soporte
                </Button>

                <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={handleRetry}
                    disabled={isLoading}
                    className="d-flex align-items-center gap-2"
                >
                    {isLoading ? (
                        <>
                            <FaSpinner className="fa-spin" />
                            Reintentando...
                        </>
                    ) : (
                        <>
                            <FaSyncAlt />
                            Reintentar
                        </>
                    )}
                </Button>
            </div>
        </Alert>
    );
};

export default InvoiceErrorState;

